import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import SafeComponent from '../../../../logged_out_homepage/shared/SafeComponent';
import { getCoreFeatures } from './utils';

const CoreFeatures = () => {
    const coreFeatures = getCoreFeatures();

    return (
        <Stack
            display="flex"
            justifyContent="center"
            hidden={{ default: true, md: false }}
            alignItems="center"
            direction={{ default: 'column', md: 'row' }}
            gap={{ default: '5', md: '10' }}
            maxWidth="100%"
            wrap="wrap"
            paddingBottom="10"
        >
            {coreFeatures.map(({ title, src }) => (
                <Stack
                    key={title}
                    direction={{ default: 'column', md: 'row' }}
                    gap={{ default: '2.5', md: '2' }}
                    alignItems="center"
                >
                    <Image alt={title} width="40px" height="40px" src={src} />
                    <Typography style={{ fontWeight: 400 }} fontSize="b_lg" color="white">
                        {title}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    );
};

export default SafeComponent(CoreFeatures);
